import { SET_VALUES_DOCUMENT, CLEAR_VALUES_DOCUMENT } from '@constants/actionType'

const initialState = {
  general: null,
  content: null,
  obligatory: null,
  visibility: null
};

function section(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_DOCUMENT:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_DOCUMENT:
      return {
        general: null,
        content: null,
        obligatory: null,
        visibility: null
      };
    default:
      return state;
  }
}

export default section;
